// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__FcyPQ","vLegacy":"SelectSecondary_vLegacy__3tsWl","error":"SelectSecondary_error__3Hg1h","disabled":"SelectSecondary_disabled__3lxho"};